(function () {
    document.addEventListener("DOMContentLoaded", () => {
        const today = new Date();
        const currentYear = today.getFullYear();

        document.getElementById('current-year').textContent = currentYear;

        // Seasonal background overrides — CSS class drives the image, not inline styles
        const christmasRanges = [
            { start: new Date(currentYear, 11, 15), end: new Date(currentYear, 11, 31) },
            { start: new Date(currentYear, 0, 1),  end: new Date(currentYear, 0, 7)  }
        ];

        const heroSection = document.querySelector("#hero");
        if (heroSection) {
            const isChristmas = christmasRanges.some(r => today >= r.start && today <= r.end);
            heroSection.classList.toggle("christmas", isChristmas);
        }
    });
})();